module.exports = __webpack_public_path__ + "fonts/baronsans-ultrahairline-webfont.2b26f578.woff";